import React, { Component } from 'react';
import InfoSpaceagencies from '../../components/InfoSpaceagencies/InfoSpaceagencies';
import AskNearspace from '../../components/AskNearspace/AskNearspace';
import SideMenuNearSpace from '../../components/SideMenuNearSpace/SideMenuNearSpace';
import NearSpaceBg from '../../components/NearSpaceBg/NearSpaceBg';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;

const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
    margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;


class NearSpace extends Component{

askearth= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('how do scientists measure earths vital signs');
        }

  render(){

   
    return(
      
        <body> 

          <SideMenuNearSpace />
          <NearSpaceBg/>
          
          
          
          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree>Near Space/</Tree>         
          </Contentwrapper>        
              <Impactwrapper><Link onClick={this.askearth}><AskNearspace/></Link></Impactwrapper>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>

              <Impactwrapper><Link to="/Near-Space_Agencies"><InfoSpaceagencies/></Link></Impactwrapper>       
              

           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>
          
          
        </body>
      
      );

  } 
}

export default NearSpace;